<template>
    <div :class="borderClass" class="col-sm bg-secondary-3 mx-1 px-4 py-3"> 
        <p :class="textClass" class="font-24 mb-0"> {{count}}</p>
        <p style="height: 80px;" class="font-16 mb-0 font-weight-normal">
        {{content}}</p>
        <p v-if="hasButton" :class="buttonContainerClass" class="mb-2 text-center">
            <action-button
            class="outline-success mr-3"
            i="fa fa-cog"
            :text="buttonText"
            @click="click()"
            />
        </p>                    
    </div>
</template>

<script>
import ActionButton from "ActionButton";

export default {
  name: "ResultRow",
  components: {
    ActionButton,
  },
  props: {
    count: {
      type: Number,
      default: 0,
    },
    content: {
      type: String,
      default: "",
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "",
    },
    buttonContainerClass: {
      type: String,
      default: "text-danger",
    },
  },
  computed: {
      borderClass(){
          if(this.count > 0)
          return "border-left-red";
          return "border-left-green";
      },
      textClass(){
          if(this.count > 0)
          return "text-red";
          return "text-green";
      }
  },
  methods: {
    click() {
        this.$emit('click')
    },
  },
};
</script>

<style lang="scss">
    @import '@/assets/scss/variables/_colors.scss';

    @media (max-width: 425px) {
    .border-left-red{
        border-top:2px solid map-get($colors, 'red')  !important;
         margin-top: 15px;
    }
    .border-left-green{
        border-top:2px solid map-get($colors, 'green')  !important;
        margin-top: 15px;
    }
  }
  @media (min-width: 425px) {
    .border-left-red{
        border-left:2px solid map-get($colors, 'red')  !important;
    }
    .border-left-green{
        border-left:2px solid map-get($colors, 'green')  !important;
    }
  }

</style>
